import { render } from "./ModalChallengeRequests.vue?vue&type=template&id=17699b90&scoped=true"
import script from "./ModalChallengeRequests.vue?vue&type=script&lang=js"
export * from "./ModalChallengeRequests.vue?vue&type=script&lang=js"

import "@/css/components/modal-challenge-requests.css?vue&type=style&index=0&id=17699b90&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17699b90"]])

export default __exports__